import React from 'react';
import { connect } from 'dva';
import styles from './index.css';

class Tag extends React.Component {

    handle_click = (tag, value) => {
        if (Number(this.props.search.para[tag]) === Number(value)) {
            return; 
        }
        this.props.dispatch({
            type: 'search/check_tag', 
            payload: { tag, value },
        });
    }

    render() {
        const rely = this.props.data.rely;
        let style = styles.tag;
        if (rely && this.props.search.para[rely.k] !== rely.v) {
            style = styles.tag_hide; 
        } else if (Number(this.props.data.id) === Number(this.props.search.para[this.props.tag])) {
            style = styles.tag_select; 
        }
        return (
        <div
            className={style}
            onClick={() => this.handle_click(this.props.tag, this.props.data.id)}
        >
            {this.props.data.name}
        </div> 
        );
    }
}

const state_props = state => {
    return {
        search: state.search, 
    }
}

export default connect(state_props)(Tag);



// WEBPACK FOOTER //
// ./src/layout/book/category/tag.js